import axios from '@/utils/axios';

export const getBusinessCards = (params = {}) => axios.get('/business-cards', { params });
export const getBusinessCard = (id) => axios.get(`/business-cards/${id}`);
export const getCardSources = (user_id) => axios.get(`/business-cards/sources/${user_id}`);
export const createBusinessCard = (payload) => axios.post('/business-cards', payload);
export const updateBusinessCard = (id, payload) => axios.put(`/business-cards/${id}`, payload);
export const deleteBusinessCard = (id) => axios.delete(`/business-cards/${id}`);
export const toggleBusinessCard = (id) => axios.patch(`/business-cards/${id}/toggle`);
export const regenerateCardToken = (id) => axios.post(`/business-cards/${id}/regenerate-token`);
export const getCardStats = (id) => axios.get(`/business-cards/${id}/stats`);
export const getPublicCard = (public_token, src) =>
  axios.get(`/public/card/${public_token}`, { params: src ? { src } : {} });
export const publicCardVcardPath = (public_token) => `/public/card/${public_token}/vcard`;

export const CARD_THEMES = [
  { label: 'Modern', value: 'modern' },
  { label: 'Classic', value: 'classic' },
  { label: 'Dark', value: 'dark' },
];

export const SOCIAL_TYPES = [
  { label: 'LinkedIn', value: 'linkedin' },
  { label: 'Instagram', value: 'instagram' },
  { label: 'Facebook', value: 'facebook' },
  { label: 'Twitter / X', value: 'twitter' },
  { label: 'YouTube', value: 'youtube' },
  { label: 'Website', value: 'website' },
];